import type { ComponentStyleConfig } from '@chakra-ui/react';

const HeadingNoMargin: ComponentStyleConfig = {
  baseStyle: {
    color: 'wl-blue.navy',
    fontWeight: 'bold',
    sup: {
      fontFamily: 'body',
      verticalAlign: 'super',
      fontSize: 'sm',
    },
    marginBlockStart: 0,
    marginBlockEnd: 0,
    margin: 0,
  },
  sizes: {
    // h1
    '3xl': {
      fontSize: 'clamp(36px, 5vw, 48px)',
      lineHeight: 'clamp(40px, 6vw, 52px)',
      fontWeight: 'bold',
    },
    // h2
    '2xl': {
      fontSize: 'clamp(32px, 4vw, 40px)',
      lineHeight: 'clamp(36px, 5vw, 48px)',
      fontWeight: 'bold',
    },
    // h3
    xl: {
      fontSize: 'clamp(24px, 3vw, 32px)',
      lineHeight: 'clamp(28px, 4vw, 36px)',
    },
    // h4
    lg: {
      fontSize: 'clamp(20px, 2vw, 24px)',
      lineHeight: 'clamp(24px, 3vw, 28px)',
      fontWeight: 'bold',
    },
    // h5
    md: {
      fontSize: 'clamp(18px, 2vw, 20px)',
      lineHeight: 'clamp(22px, 2.5vw, 24px)',
      fontWeight: 'bold',
    },
    // h6
    sm: {
      fontSize: 'clamp(16px, 1.5vw, 18px)',
      lineHeight: 'clamp(20px, 2vw, 22px)',
      fontWeight: 'bold',
    },
  },
  defaultProps: {
    size: '2xl',
  },
};

export default HeadingNoMargin;
